import TuneIcon from '@mui/icons-material/Tune'
import { FormControl, MenuItem, Select } from '@mui/material'
import cn from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { setCookie } from '../helpers/cookies'
import { Context } from '../waxplorer/Waxplorer'
import QuickSettingsItem from './QuickSettingsItem'
import { WharfKit } from '../waxplorer/WharfKit'

const apiMappings = {
    'https://api.waxsweden.org': 'WaxSweden',
    'https://wax.eosphere.io': 'EosSphere',
}

export default function QuickSettingsDown({
    skipBuyConfirmation,
    changeSkipBuyConfirmation,
    playAnimations,
    changeAutoPlay,
    generateSets,
    changeGenerateSets,
    changeFilter,
    hasNotifications,
    handleChangeNotifications,
    userFilters,
}) {
    const { t } = useTranslation('common')
    const [isHovered, setIsHovered] = useState(false) // state to track hover
    const [state, dispatch] = useContext(Context)

    const fadeInOut = {
        hidden: { opacity: 0, y: 0 },
        visible: { opacity: 1, y: 0 },
    }

    const changeAPI = (e) => {
        dispatch({
            type: 'API',
            payload: e.target.value,
        })
        WharfKit.getInstance(e.target.value).setEndpoint(e.target.value)
        setCookie('nfthive-api', e.target.value)
    }

    return (
        <div
            className="relative hidden lg:block"
            onMouseEnter={() => {
                setIsHovered(true)
            }}
            onMouseLeave={() => setIsHovered(false)} // to hide the div when the mouse leaves
        >
            <button className="lg:hidden bg-white dark:bg-zinc-900 hover:bg-zinc-200 hover:dark:!bg-zinc-800 h-full flex items-center justify-center rounded-md bg-blue-600 px-2 py-2 text-[16px] font-normal leading-6">
                <TuneIcon className="md:w-6 w-5 md:h-6 h-5" />
            </button>

            <button
                className={cn(
                    'font-semibold hidden lg:flex items-center px-3 py-3 rounded-md cursor-pointer',
                    {
                        'dark:bg-zinc-900 bg-zinc-200': !isHovered,
                        'dark:bg-zinc-800 bg-zinc-400': isHovered,
                    },
                )}
                aria-haspopup="true"
            >
                <TuneIcon className="h-6 w-6 text-black dark:text-white" />
            </button>
            <AnimatePresence>
                {isHovered && (
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        variants={fadeInOut}
                        transition={{ duration: 0.1, ease: 'easeInOut' }}
                        className="absolute -right-24 lg:right-0 top-[48px] z-50 min-w-[300px]"
                    >
                        <div className="p-4 md:p-6 border border-zinc-100 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-900 rounded-xl shadow-xl w-full">
                            <div className="relative z-10 space-y-2">
                                <QuickSettingsItem
                                    handleCheck={skipBuyConfirmation}
                                    handleOnChange={changeSkipBuyConfirmation}
                                    title={t('navigation.skip_confirmation')}
                                    description={t(
                                        'navigation.skip_confirmation_when_buy_nfts',
                                    )}
                                />

                                <QuickSettingsItem
                                    handleCheck={playAnimations}
                                    handleOnChange={changeAutoPlay}
                                    title={t('navigation.play_animations')}
                                    description={t(
                                        'navigation.auto_play_animations',
                                    )}
                                />

                                <QuickSettingsItem
                                    handleCheck={
                                        !userFilters ||
                                        !userFilters.includes(71)
                                    }
                                    handleOnChange={() => changeFilter(71)}
                                    title={t('navigation.show_nsfw_content')}
                                    description={t(
                                        'navigation.nsfw_filter_explanation',
                                    )}
                                />

                                <QuickSettingsItem
                                    handleCheck={
                                        !userFilters ||
                                        !userFilters.includes(72)
                                    }
                                    handleOnChange={() => changeFilter(72)}
                                    title={t('navigation.show_ai_content')}
                                    description={t(
                                        'navigation.ai_filter_explanation',
                                    )}
                                />

                                <div className="pt-2">
                                    <div
                                        className={cn(
                                            'relative text-left text-[14px] md:text-[16px] mb-4',
                                            'dark:text-white text-black mr-auto',
                                        )}
                                    >
                                        {t('navigation.api_endpoint')}
                                    </div>

                                    <FormControl
                                        fullWidth
                                        size="small"
                                        id={'idk'}
                                    >
                                        <Select
                                            variant="outlined"
                                            // label="API Endpoint"
                                            value={state.api}
                                            onChange={changeAPI}
                                            id={'api_select'}
                                        >
                                            {Object.entries(apiMappings).map(
                                                ([key, value]) => (
                                                    <MenuItem
                                                        value={key}
                                                        id={'item_' + value}
                                                        key={'item_' + value}
                                                    >
                                                        {value}
                                                    </MenuItem>
                                                ),
                                            )}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}
